import {wizard} from '@/config/sites'

const navigateToTab = () => {
  window.open(`crea-corso`, '_blank')
}

export default {
  'bindTo': false,
  'method': navigateToTab,
}
